import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Dialog, InputText, Toast } from "primereact";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";

import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { useForm } from "../../../Base/Hooks/useForm";
import Loader from "../../../Base/Components/Loader/Loader";
import AutoCompleteDropdown from "../../../Base/Components/Form/AutoCompleteDropdown";
import { toastShow } from "../../../Base/Services/ToastService";

import { ObtenerCurrency } from "../../../Base/API/Global/Currency/CurrencyRequest";
import { getEstadosCategory } from "../../../API/Global/Status/StatusRequests";
import { EditarCharAccount, getAccountType, getCategories, getCharAccountConcat, getCuentasExistentes, getSubCategories, GuardarCharAccount } from "../../../API/Finanzas/RegistroContable/RegistroContableRequest";

const CharAccountCRUD = ({
    showDialog,
    selected,
    setSelected,
    setShowDialog,
    getInfo,
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [tiposCuentas, setTiposCuentas] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [dialogTitle, setDialogTitle] = useState('');
  const [checked, setChecked] = useState(false);
  const [cuentasConcat, setCuentasConcat] = useState([]);
  const [cuentasHermana, setCuentasHermanas] = useState([])


  const initialValues = {
    IdAccount: -1,
    IdStatus: selected?.IdStatus ? selected?.IdStatus : 5,
    StatusName: selected?.StatusName ? selected?.StatusName : 'Activo',
    Type: '',
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    
    const estadosTempo = await getEstadosCategory('General')
    let est = estadosTempo.filter(i=> i?.IdStatus !== 7) 

    const tiposTempo = await getAccountType()
    setTiposCuentas(tiposTempo)

    const cateTempo = await getCategories()
    setCategories(cateTempo)

    const subCatTempo = await getSubCategories()
    setSubCategories(subCatTempo)

    const currenciesTempo = await ObtenerCurrency()
    setCurrencies(currenciesTempo)

    const cuentasTempo = await getCharAccountConcat()
    setCuentasConcat(cuentasTempo)

    const tempo3 = await getCuentasExistentes()
    let tempoCuentasHermanas = tempo3.filter((e) => [6,7].includes(e.IdCategoria))
    setCuentasHermanas(tempoCuentasHermanas)
    let categoriaInicial

    let estadoInicial
    if(selected?.IdAccount){
        setDialogTitle("Editar Cuenta")
        estadoInicial =  estadosTempo.find((e) => e.IdStatus === selected?.IdStatus);
        if(selected?.IdContenedorAccount){
            setChecked(true)
        }
        categoriaInicial = cateTempo.filter(i => i?.IdCategoria === selected?.IdCategoria)
    }else{
        setDialogTitle("Agregar Cuenta")
        estadoInicial =  estadosTempo[0]
    }
    setEstados(est)

    setValues({
        ...selected,
        IdAccount: selected?.IdAccount > 0 ? selected?.IdAccount : -10,
        IdStatus: estadoInicial?.IdStatus,
        StatusName: estadoInicial,
        IdClase: selected?.IdClase ? selected?.IdClase : null,
        Clase: selected?.Clase ? selected?.Clase : '',
        Categoria: categoriaInicial[0]
    })
    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
    setSelected(null)
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.Type?.IdType && !values?.IdType) {
        error.IdType = true;
        error.error = true;
    }
    if (!values.Account) {
      error.Account = true;
      error.error = true;
    }
    if(values?.Type?.IdType === 6 || values?.IdType === 6){
        if(!values?.Categoria?.IdCategoria && !values?.IdCategoria){
            error.IdCategoria = true;
            error.error = true;
        }
    }
    if(!values?.SubCategoria?.IdSubCategoria && !values?.IdSubCategoria){
        error.IdSubCategoria = true;
        error.error = true;
    }
    if(!values?.Divisa?.IdCurrency && !values?.IdCurrency){
        error.IdCurrency = true;
        error.error = true;
    }
    if (!values.CodigoAccount) {
        error.CodigoAccount = true;
        error.error = true;
    }
    if (!values.StatusName?.IdStatus && !values?.IdStatus) {
        error.IdStatus = true;
        error.error = true;
    }
    if (!values.Description) {
        error.Description = true;
        error.error = true;
    }
    // if (!values.Saldo) {
    //     error.Saldo = true;
    //     error.error = true;
    // }
    if(checked){
        if (!values.CuentaConcatenadaCont?.IdAccount && !values?.IdContenedorAccount) {
            error.IdContenedorAccount = true;
            error.error = true;
        }
    }

    setError(error);
    return error;
  };

  const agregarInformacion = async () => {
    const e = verificarInfo();
    if(!e?.error){

        const Datos = {
            IdAccount: values?.IdAccount ? values?.IdAccount : -100,
            Account: values?.Account,
            IdCategoria: values?.Categoria?.IdCategoria || values?.IdCategoria,
            IdSubCategoria: values?.SubCategoria?.IdSubCategoria || values?.IdSubCategoria,
            IdCurrency: values?.Divisa?.IdCurrency || values?.IdCurrency,
            CodigoAccount: values?.CodigoAccount,
            IdStatus: values?.StatusName?.IdStatus || values?.IdStatus,
            Description: values?.Description,
            Saldo: values?.Saldo,
            IdContenedorAccount: values?.CuentaConcatenadaCont?.IdAccount || values?.IdContenedorAccount,
            IdUserCreate: userAuth?.IdUser,
            IdUserEdit: userAuth?.IdUser,
            IdCuentaHermana: values?.Cuenta?.IdAccount || values?.IdCuentaHermana
        }

        console.log(Datos);

        setLoading(true)
        if(Datos?.IdAccount > 0){
            const respuesta = await EditarCharAccount(Datos)
            if (respuesta[0].ESTADO !== -1) {
                toastShow(toast, "success", "Editado", respuesta[0].MENSAJE);
                setTimeout(() => {
                    onHide();
                    setLoading(false);
                    getInfo();
                }, 1500);
            } else {
                toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
                setLoading(false);
            }
        }else{
            const respuesta = await GuardarCharAccount(Datos)
            if (respuesta[0].ESTADO !== -1) {
                toastShow(toast, "success", "Guardado", respuesta[0].MENSAJE);
                setTimeout(() => {
                    onHide();
                    setLoading(false);
                    getInfo();
                }, 1500);
            } else {
                toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
                setLoading(false);
            }
        }

    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={"Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarInformacion}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
        getValoresIniciales();
    }
  }, [showDialog]);


  useEffect(() => {
    if (values?.Type?.IdType || values?.IdType) {
        let IdType = values?.Type?.IdType || values?.IdType
        let IdCategoria
        let Categoria

        if(IdType === 1){
            IdCategoria =1
            Categoria="Activo"
        }else if(IdType === 2){
            IdCategoria = 2
            Categoria = "Pasivo"
        }else if (IdType === 3){
            IdCategoria = 3
            Categoria = 'Patrimonio'
        }else if(IdType === 4 ){
            IdCategoria = 4
            Categoria = 'Ingresos'
        }else if (IdType === 5){
            IdCategoria = 5
            Categoria = 'Costos'
        }else{
            IdCategoria = null
            Categoria = null
        }
        setValues({
            ...values,
            Categoria: Categoria,
            IdCategoria: IdCategoria,
            IdSubCategoria: null,
            SubCategoria: null,
        })
    }
  }, [values?.Type?.IdType]);


  useEffect(() => {
    if(!values?.Categoria?.IdCategoria){
        setValues({
            ...values,
            IdSubCategoria: null,
            SubCategoria:'',
        })
    }
  }, [values?.Categoria?.IdCategoria]);

  
  useEffect(() => {
    if(values?.Categoria?.IdCategoria !== values?.IdCategoria){
        setValues({
            ...values,
            IdSubCategoria: null,
            SubCategoria:'',
        })
    }
  }, [values?.Categoria?.IdCategoria]);

  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center">
              <h3 className="mx-4">{dialogTitle}</h3>
            </div>
            <Toast ref={toast}/>

            <div className="modal__input-contenedor">
                <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                        <AutoCompleteDropdown
                            name={"Type"}
                            value={values.Type}
                            items={tiposCuentas}
                            field={"Type"}
                            label={"Tipo Cuenta"}
                            handleInputChange={handleInputChange}
                            className={error.IdType ? "p-invalid" : ""}
                        />
                    </span>
                </div>

                <div className="field col-6 me-2  mt-2">
                    <span className="p-float-label">
                        <InputText
                            name="Account"
                            value={values.Account}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            className={error.Account ? "p-invalid" : ""}
                        />
                        <label htmlFor="Account">Nombre</label>
                    </span>
                </div>
            </div>

            <div className="modal__input-contenedor">
                {(values?.Type?.IdType === 6 || values?.IdType === 6) && (
                    <div className="field col-6 me-2 mt-2">
                        <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"Categoria"}
                                value={values?.Categoria}
                                items={categories}
                                field={"Categoria"}
                                label={"Categoría"}
                                enable={values?.IdType === 6}
                                handleInputChange={handleInputChange}
                                className={error.IdCategoria ? "p-invalid" : ""}
                                filterValue={values?.Type}
                                itemsFilter={(e) => {
                                    let IdType = values?.Type?.IdType || values?.IdType
                                    let filtro = categories.filter((s) => s.IdType === IdType)
                                    let filtro2 = values?.Type?.IdType
                
                                    if(filtro?.length === 0 && filtro2){
                                        toastShow( toast, "warn", "Advertencia", "El Tipo de cuenta seleccionada no cuenta con estantes disponibles" );
                                    }
                                    return filtro
                                }}
                            />
                        </span>
                    </div>
                )}
                


                <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                        <AutoCompleteDropdown
                            name={"SubCategoria"}
                            value={values.SubCategoria}
                            items={subCategories}
                            field={"SubCategoria"}
                            label={"Sub Categoría"}
                            handleInputChange={handleInputChange}
                            className={error.IdSubCategoria ? "p-invalid" : ""}
                            filterValue={values?.Type}
                            itemsFilter={(e) => {
                                let IdCat = values?.Categoria?.IdCategoria || values?.IdCategoria
                                let filtro = subCategories.filter((s) => s.IdCategoria === IdCat)
                                let filtro2 = IdCat
                                if(filtro?.length === 0 && filtro2){
                                    toastShow( toast, "warn", "Advertencia", "La Categoría seleccionada no cuenta con subCategorias disponibles" );
                                }
                                return filtro
                            }}
                        />
                    </span>
                </div>

            </div>

            <div className="modal__input-contenedor">
                <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                        <AutoCompleteDropdown
                            name={"Divisa"}
                            value={values.Divisa}
                            items={currencies}
                            field={"Divisa"}
                            label={"Divisa"}
                            handleInputChange={handleInputChange}
                            className={error.IdCurrency ? "p-invalid" : ""}
                        />
                    </span>
                </div>
                <div className="field col-6 me-2  mt-2">
                    <span className="p-float-label">
                        <InputNumber
                            name="CodigoAccount"
                            value={values.CodigoAccount}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            useGrouping={false}
                            className={error.CodigoAccount ? "p-invalid" : ""}
                        />
                        <label htmlFor="CodigoAccount">No. Cuenta</label>
                    </span>
                </div>
            </div>

            <div className="modal__input-contenedor">
                <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                        <AutoCompleteDropdown
                            name={"StatusName"}
                            value={values.StatusName}
                            items={estados}
                            field={"StatusName"}
                            label={"Estado"}
                            handleInputChange={handleInputChange}
                            enable={dialogTitle !== 'Agregar Cuenta'}
                            className={error.IdStatus ? "p-invalid" : ""}
                        />
                    </span>
                </div>
                <div className="field col-6 me-2  mt-2">
                    <span className="p-float-label">
                        <InputText
                            name="Description"
                            value={values.Description}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            className={error.Description ? "p-invalid" : ""}
                        />
                        <label htmlFor="Description">Descripción</label>
                    </span>
                </div>
            </div>

            <div className="modal__input-contenedor">
                <div className="field col-6 me-2 mt-3">
                    <span className="p-float-label">
                        <Checkbox onChange={e => setChecked(e.checked)} checked={checked}> </Checkbox>
                        <label htmlFor="ingredient1" className="ml-2" style={{ marginLeft: 10 }}>  Es una cuenta secundaria</label>
                    </span>
                </div>
                <div className="field col-6 me-2  mt-2">
                    <span className="p-float-label">
                        <InputNumber
                            name="Saldo"
                            value={values.Saldo}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            className={error.Saldo ? "p-invalid" : ""}
                            minFractionDigits={2}
                        />
                        <label htmlFor="Saldo">Saldo</label>
                    </span>
                </div>
            </div>

            {checked && (
                <div className="modal__input-contenedor">
                    <div className="field col-6 me-2 mt-2">
                        <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"CuentaConcatenadaCont"}
                                value={values.CuentaConcatenadaCont}
                                items={cuentasConcat}
                                field={"CuentaConcatenadaCont"}
                                label={"Cuenta"}
                                handleInputChange={handleInputChange}
                                className={error.IdContenedorAccount ? "p-invalid" : ""}
                            />
                        </span>
                    </div>

                </div>
            )}

            <div className="modal__input-contenedor">
                <div className="field col-6 me-2 mt-2">

                </div>
                {(values?.Categoria?.IdCategoria === 6 || values?.IdCategoria) && (
                    <div className="field col-6 me-2 mt-2">
                        <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"Cuenta"}
                                value={values.Cuenta}
                                items={cuentasHermana}
                                field={"Cuenta"}
                                label={"Cuenta Hermana"}
                                handleInputChange={handleInputChange}
                                className={error.IdCuentaHermana ? "p-invalid" : ""}
                            />
                        </span>
                    </div>
                )}
        
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default CharAccountCRUD;
